import React from 'react';
import { TabNavigation, TabButton, TabIcon } from '../../../pages/admin/components/styled';

export type SuperAdminTabType = 'overview' | 'companies' | 'upload' | 'credits' | 'settings';

interface SuperAdminTabNavigationProps {
  activeTab: SuperAdminTabType;
  onTabChange: (tab: SuperAdminTabType) => void;
}

// Move static tabs array outside component to avoid recreation on each render
const tabs = [
  {
    id: 'overview' as SuperAdminTabType,
    label: 'System Overview',
    icon: '📊'
  },
  {
    id: 'companies' as SuperAdminTabType,
    label: 'All Companies',
    icon: '🏢'
  },
  {
    id: 'upload' as SuperAdminTabType,
    label: 'Upload Files',
    icon: '📤'
  },
  {
    id: 'credits' as SuperAdminTabType,
    label: 'Company Credits',
    icon: '💎'
  },
  {
    id: 'settings' as SuperAdminTabType,
    label: 'Platform Settings',
    icon: '⚙️'
  }
];

const SuperAdminTabNavigation: React.FC<SuperAdminTabNavigationProps> = ({
  activeTab,
  onTabChange
}) => {
  return (
    <TabNavigation>
      {tabs.map((tab) => (
        <TabButton
          key={tab.id}
          $active={activeTab === tab.id}
          onClick={() => onTabChange(tab.id)}
        >
          <TabIcon>{tab.icon}</TabIcon>
          {tab.label}
        </TabButton>
      ))}
    </TabNavigation>
  );
};

export default SuperAdminTabNavigation;
